import { Button, Card, FILockClosed, Icon, IconLib, Link, Text, View } from '@fold-dev/core'
import { useMemo } from 'react'
import { TbHash, TbMessageCircle } from 'react-icons/tb'
import { plural } from '../../helpers'

export const ProjectCard = ({ project, onJoin, onLeave, onNavigate }) => {
    const isMember = useMemo(() => !!project.projectUserId, [project.projectUserId])
    const { color, background, backgroundCard, borderColor } = useMemo(() => {
        return {
            backgroundCard: project.color ? `rgb(from ${project.color} r g b / 10%)` : 'var(--f-color-surface-strong)',
            background: project.color ? `rgb(from ${project.color} r g b / 15%)` : 'var(--f-color-surface-stronger)',
            color: project.color ? project.color : 'var(--f-color-text)',
            borderColor: project.color ? `rgb(from ${project.color} r g b / 20%)` : 'var(--f-color-border-strong)',
        }
    }, [project])

    return (
        <Card
            column
            border="none"
            shadow="none"
            style={{ overflow: 'hidden' }}
            position="relative"
            width="100%"
            height="fit-content"
            p="1.25rem"
            alignItems="flex-start"
            bg={backgroundCard}
            colorToken="text"
            gap="0.5rem">
            <Link
                onClick={onNavigate}
                size="lg"
                color={color}
                row
                justifyContent="flex-start"
                gap="0.5rem"
                style={{ width: '100%' }}
                className="f-underline f-ellipsis">
                {/* {!project.isChannel && project.icon && <IconLib icon={project.icon} />} */}
                {project.isChannel && <Icon icon={TbMessageCircle} />}
                <span
                    className="f-ellipsis"
                    style={{ color: 'inherit' }}>
                    {project.name}
                </span>
            </Link>
            <View
                row
                color={color}
                gap={4}>
                <Text
                    size="sm"
                    colorToken="inherit">
                    {project.members} {plural(project.members, 'Member')}
                </Text>
                {project.isClosed && (
                    <Icon
                        size="sm"
                        icon={FILockClosed}
                    />
                )}
            </View>
            <View
                row
                gap="1rem"
                m="0.4rem 0 0 0">
                <Button
                    className="f-buttonize"
                    style={{ borderColor }}
                    color={isMember ? color : 'rgba(255,255,255,0.75)'}
                    bg={isMember ? background : color}
                    onClick={() => (isMember ? onLeave(project) : onJoin(project))}>
                    {isMember ? 'Leave' : 'Join'}
                </Button>
            </View>
        </Card>
    )
}
